import mutations from './maintenanceMutation';
import actions from './maintenanceAction';
import getters from './maintenanceGetter';

const state = {
  maintenance: {},
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/maintenance/maintenanceStore.js